import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reverse'
})
export class ReversePipe implements PipeTransform {

  transform(value) {
    return value.slice().reverse();
  }

}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/reverse.pipe.ts